// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-card {
  border-radius: 10px;
  height: 270px;
}

ion-card-subtitle {
  font-weight: bold;
  white-space: normal !important;
}

ion-card-content {
  padding-bottom: 5px;
  padding-top: 5px;
  background: var(--ion-color-primary);
  color: var(--ion-color-primary-contrast);
  position: absolute;
  bottom: 0;
  width: 100%;
}

.btn-favorito {
  position: absolute;
  top: 0;
  right: 3px;
}

.imagen {
  width: 176px;
  height: 150px;
  object-fit: cover;
}

.is-public {
  color: var(--ion-color-success);
}

.card_more_info {
  width: 100%;
  height: 270px;
  min-width: 150px;
  margin-top: 12px;
}
.card_more_info .btn_more_info {
  text-align: center;
  color: var(--ion-color-primary);
  font: 2rem;
  /* Center vertically and horizontally */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.card_more_info .btn_more_info ion-icon {
  font-size: 4rem;
}

.tag_date {
  position: absolute;
  top: 0px;
  left: 10px;
  text-align: center;
  padding: 5px;
  background: var(--ion-color-primary);
  padding-top: 10px;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
  color: var(--ion-color-primary-contrast);
  font-size: 0.8rem;
}

@media (max-width: 330px) {
  ion-card {
    height: 240px;
  }
  ion-card .imagen {
    width: 126px;
    height: 120px;
  }
  ion-card ion-card-subtitle {
    font-weight: normal;
    font-size: 0.8rem;
  }
  ion-card ion-card-content h2 {
    font-size: 0.9rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/producto-tarjeta/producto-tarjeta.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,aAAA;AACJ;;AACA;EACI,iBAAA;EACA,8BAAA;AAEJ;;AAAA;EACI,mBAAA;EACA,gBAAA;EACA,oCAAA;EACA,wCAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AAGJ;;AADA;EACI,kBAAA;EACA,MAAA;EACA,UAAA;AAIJ;;AAFA;EACI,YAAA;EACA,aAAA;EACA,iBAAA;AAKJ;;AAHA;EACI,+BAAA;AAMJ;;AAJA;EACI,WAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AAOJ;AANI;EACI,kBAAA;EACA,+BAAA;EACA,UAAA;EAIA,uCAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAKR;AAZQ;EACI,eAAA;AAcZ;;AAJA;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,oCAAA;EACA,iBAAA;EACA,+BAAA;EACA,8BAAA;EACA,wCAAA;EACA,iBAAA;AAOJ;;AAHA;EACI;IACI,aAAA;EAMN;EALM;IACI,YAAA;IACA,aAAA;EAOV;EALM;IACI,mBAAA;IACA,iBAAA;EAOV;EAJU;IACI,iBAAA;EAMd;AACF","sourcesContent":["ion-card{\r\n    border-radius: 10px;\r\n    height: 270px;\r\n}\r\nion-card-subtitle{\r\n    font-weight: bold;\r\n    white-space: normal !important;\r\n}\r\nion-card-content{\r\n    padding-bottom: 5px;\r\n    padding-top: 5px;\r\n    background: var(--ion-color-primary);\r\n    color: var(--ion-color-primary-contrast);\r\n    position: absolute;\r\n    bottom: 0;\r\n    width: 100%;\r\n}\r\n.btn-favorito{\r\n    position: absolute;\r\n    top: 0;\r\n    right: 3px;\r\n}\r\n.imagen{\r\n    width: 176px;\r\n    height: 150px;\r\n    object-fit: cover;\r\n}\r\n.is-public{\r\n    color: var(--ion-color-success);\r\n}\r\n.card_more_info{\r\n    width: 100%;\r\n    height: 270px;\r\n    min-width: 150px;\r\n    margin-top: 12px;\r\n    .btn_more_info{\r\n        text-align: center;\r\n        color: var(--ion-color-primary);\r\n        font: 2rem;\r\n        ion-icon{\r\n            font-size: 4rem;\r\n        }\r\n        /* Center vertically and horizontally */\r\n        position: absolute;\r\n        top: 50%;\r\n        left: 50%;\r\n        transform: translate(-50%, -50%);\r\n    }\r\n}\r\n\r\n.tag_date{\r\n    position: absolute;\r\n    top: 0px;\r\n    left: 10px;\r\n    text-align: center;\r\n    padding: 5px;\r\n    background: var(--ion-color-primary);\r\n    padding-top: 10px;\r\n    border-bottom-right-radius: 5px;\r\n    border-bottom-left-radius: 5px;\r\n    color: var(--ion-color-primary-contrast);\r\n    font-size: .8rem;\r\n}\r\n\r\n// Pantallas movil pequeñas (Ej.: Iphone 5)\r\n@media (max-width: 330px){\r\n    ion-card{\r\n        height: 240px;\r\n        .imagen{\r\n            width: 126px;\r\n            height: 120px;\r\n        }\r\n        ion-card-subtitle{\r\n            font-weight: normal;\r\n            font-size: .8rem;\r\n        }\r\n        ion-card-content{\r\n            h2{\r\n                font-size: .9rem;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
